import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import RichTextEditor from 'react-rte/lib/RichTextEditor'
import _ from 'common-tools/LodashHelper'

const toolbarConfig = {
  // Optionally specify the groups to display (displayed in the order listed).
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'HISTORY_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' }
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' }
  ]
}

class TextRTEBoxClass extends React.Component {
  constructor (props) {
    super(props)
    const { defaultValue, input } = props
    const val = (input && input.value) != null ? input.value : defaultValue

    this.state = {
      editorValue: val ? RichTextEditor.createValueFromString(val, 'html') : RichTextEditor.createEmptyValue()
    }
  }

  componentDidMount () {
    const { defaultValue, input } = this.props
    const val = (input && input.value) != null ? input.value : defaultValue
    if (val && !this.state.editorValue.toString('html')) {
      this.setState({
        editorValue: RichTextEditor.createValueFromString(val, 'html')
      })
    }
  }

  componentDidUpdate (prevProps) {
    const { defaultValue: prevDefaultValue, input: prevInput } = prevProps
    const { defaultValue, input } = this.props
    const prevVal = (prevInput && prevInput.value) != null ? prevInput.value : prevDefaultValue
    const curVal = (input && input.value) != null ? input.value : defaultValue

    if (curVal !== prevVal && curVal !== this.state.editorValue.toString('html')) {
      this.setState({
        editorValue: curVal ? RichTextEditor.createValueFromString(curVal, 'html') : RichTextEditor.createEmptyValue()
      })
    }
  }

  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })

  onEditorChange = (value) => {
    const { input } = this.props
    if (input && input.onChange) {
      try {
        input.onChange(value.toString('html'))
      } catch (err) {
        console.log(err)
      }
    }

    this.setState({
      editorValue: value
    })
  }

  render () {
    const { type, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => {
          return <RichTextEditor id={`textrte${name}`} toolbarConfig={toolbarConfig} onChange={this.onEditorChange} value={this.state.editorValue} />
        //   if (readonly) {
        //     return <Input type='text' readOnly name={`view${name}`} id={`view${name}`} value={value} />
        //   } else {
        //     return <Input type={inputType} invalid={showError} name={`text${name}`} id={`text${name}`} placeholder={placeHolder} onChange={onChange} value={value} />
        //   }
        }}
      </FieldLayoutBox>
    )
  }
};

export const TextRTEBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={TextRTEBoxClass} /> } // eslint-disable-line
export default TextRTEBox
